/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateJobArchiveRequest {
    getFixupPrototypeFunction() { return TemplateJobArchiveRequest.fixupPrototype; }

    static newInstance(model: Partial<TemplateJobArchiveRequest>): TemplateJobArchiveRequest {
        let obj = Object.assign(new TemplateJobArchiveRequest(), model);
        TemplateJobArchiveRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateJobArchiveRequest>): TemplateJobArchiveRequest {
        if (!model) return null;
        return TemplateJobArchiveRequest.newInstance(<TemplateJobArchiveRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateJobArchiveRequest) {
        if (!obj) return;

        models.TemplateJobArchiveRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateJobArchiveRequest): boolean {
        Object.setPrototypeOf(obj, TemplateJobArchiveRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Template job IDs to archive/unarchive
     */
    job_ids: Array<string>;

}
